import { useRecoilState } from 'recoil';
import roomDetailState, { PickType } from '../../atoms/roomDetail';
import './Picks.scoped.scss';

function getPickText(pickType: PickType) {
  if (pickType === PickType.NONE) {
    return '선택 안함';
  } else if (pickType === PickType.BLUE) {
    return '파랑거북이';
  } else if (pickType === PickType.RED) {
    return '빨강거북이';
  } else if (pickType === PickType.GREEN) {
    return '녹색거북이';
  }
}

function Picks() {
  const [roomDetail] = useRecoilState(roomDetailState);

  const pickComponents = roomDetail.pickHistory.map((pickHistoryItem) => {
    return (
      <div style={{ marginBottom: '10px', }}>
        <div>{pickHistoryItem.date} / {pickHistoryItem.round}</div>
        <div>결과: {pickHistoryItem.result !== PickType.NONE ? getPickText(pickHistoryItem.result) : '대기'}</div>
        <div>방장 픽: {getPickText(pickHistoryItem.pick)}</div>
      </div>
    )
  });

  return (
    <div className="picks">
      <div className="picks__header">
        방장픽 정보
      </div>
      <div className="picks__contents">
        {pickComponents}
      </div>
    </div>
  );
}

export default Picks;
